import { Outlet } from "react-router-dom";

export default function PublicBookingLayout() {
  return (
    <>
      <Outlet />
    </>
  );
}
